// tanstack
import { Link } from '@tanstack/react-router';

// material ui icons
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

// material ui
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import AlarmTypeCardHeader from '../AlarmTypeCardHeader';

// Need a data window of 24 hours +- 12 hours before and after DataFrom and DataTo

const MaxThresholdExceeded = ({ alarm }: { alarm: ReadAlarmDto }) => {
  console.log('Rendering MaxThresholdExceeded with alarm:', alarm);
  const unitId = alarm?.Associations?.['Units']?.[0] || 'Unknown Unit';
  const viewUnitText = 'View Unit';
  return (
    <Card>
      <AlarmTypeCardHeader
        alarm={alarm}
        title="Max Threshold Exceeded"
        avatarIcon={<TrendingUpIcon />}
      />
      <Divider />
      <CardContent>
        <Typography variant="body1">{alarm.Details}</Typography>
      </CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          component={Link}
          to={'/$accountId/units/' + unitId}
          size="small"
          color="primary"
        >
          {viewUnitText}
        </Button>
      </CardActions>
    </Card>
  );
};

export default MaxThresholdExceeded;
